import { render, staticRenderFns } from "./photoDisplay.vue?vue&type=template&id=d9fa2a74&scoped=true&"
import script from "./photoDisplay.vue?vue&type=script&lang=js&"
export * from "./photoDisplay.vue?vue&type=script&lang=js&"
import style0 from "./photoDisplay.vue?vue&type=style&index=0&id=d9fa2a74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9fa2a74",
  null
  
)

export default component.exports